import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/verify-email";
import { buildNoindexHead } from "@/lib/noindex-seo";

export const Route = createFileRoute("/verify-email")({
  head: () => buildNoindexHead("Verify Your Email", "/verify-email"),
  component: Page,
});
